/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DrawPrize } from './DrawPrize';
import {
    DrawPrizeFromJSON,
    DrawPrizeFromJSONTyped,
    DrawPrizeToJSON,
    DrawPrizeToJSONTyped,
} from './DrawPrize';
import type { DrawQualification } from './DrawQualification';
import {
    DrawQualificationFromJSON,
    DrawQualificationFromJSONTyped,
    DrawQualificationToJSON,
    DrawQualificationToJSONTyped,
} from './DrawQualification';
import type { RewardSelection } from './RewardSelection';
import {
    RewardSelectionFromJSON,
    RewardSelectionFromJSONTyped,
    RewardSelectionToJSON,
    RewardSelectionToJSONTyped,
} from './RewardSelection';

/**
 * 
 * @export
 * @interface ChallengeDraw
 */
export interface ChallengeDraw {
    /**
     * 
     * @type {string}
     * @memberof ChallengeDraw
     */
    _id?: string;
    /**
     * Unix timestamp (ms) when the draw fires
     * @type {number}
     * @memberof ChallengeDraw
     */
    drawAt: number;
    /**
     * 
     * @type {RewardSelection}
     * @memberof ChallengeDraw
     */
    qualificationMode: RewardSelection;
    /**
     * Inline prize entries owned by this draw. Each entry pairs a RewardConfig with a quantity. RewardConfigs are created via the admin draw modal and conceptually scoped to this draw (not shared via a global catalog).
     * @type {Array<DrawPrize>}
     * @memberof ChallengeDraw
     */
    prizes: Array<DrawPrize>;
    /**
     * Optional admin-facing label (e.g. "Bi-Weekly Giveaway
     * @type {string}
     * @memberof ChallengeDraw
     */
    label?: string;
    /**
     * When true, executeDraw fires handleRewardDistribution immediately after picking winners. When false (default), executeDraw stops after winner selection and admin must explicitly click "Distribute" in the admin Draws tab to trigger reward distribution. Manual mode lets admins sanity-check the winner list before prizes ship.
     * @type {boolean}
     * @memberof ChallengeDraw
     */
    autoDistributedRewards: boolean;
    /**
     * Unix timestamp (ms) when executeDraw atomically claimed this draw — idempotency anchor for winner-selection retries
     * @type {number}
     * @memberof ChallengeDraw
     */
    drawCompletedAt?: number;
    /**
     * Unix timestamp (ms) when handleRewardDistribution successfully ran. Distinct from drawCompletedAt — a manual-mode draw can be complete (winners selected) but rewards not yet distributed (admin hasn't approved). Both set means fully distributed.
     * @type {number}
     * @memberof ChallengeDraw
     */
    rewardsDistributedAt?: number;
    /**
     * Count of winners selected (sum of awarded reward quantities). Only populated after drawCompletedAt is set. The actual winner IDs are intentionally not in the public response — exposing them would leak PII-adjacent identity anchors and create a social-engineering surface (fake prize notifications). Admin endpoints surface the full winner list separately.
     * @type {number}
     * @memberof ChallengeDraw
     */
    winnerCount?: number;
    /**
     * DEPRECATED. Use `qualification` instead. Preserved on the response so older admin clients keep working until they regenerate.
     * @type {boolean}
     * @memberof ChallengeDraw
     */
    requireSegmentActivity?: boolean;
    /**
     * 
     * @type {DrawQualification}
     * @memberof ChallengeDraw
     */
    qualification?: DrawQualification;
    /**
     * Set by the cascade re-validator when a segment mutation invalidates this draw (e.g. segment dates shifted so drawAt no longer falls inside any segment window while requireSegmentActivity=true). Surfaced in the admin UI as a red state chip. Cloud Task is canceled on transition into this state; execute endpoint refuses to fire with a 409 as a backstop.
     * @type {boolean}
     * @memberof ChallengeDraw
     */
    requiresAttention?: boolean;
    /**
     * Human-readable explanation of why requiresAttention=true, shown to admins in the Drawings tab. Cleared when the underlying issue is resolved (admin edits drawAt or the segment edit is reverted).
     * @type {string}
     * @memberof ChallengeDraw
     */
    attentionReason?: string;
}



/**
 * Check if a given object implements the ChallengeDraw interface.
 */
export function instanceOfChallengeDraw(value: object): value is ChallengeDraw {
    if (!('drawAt' in value) || value['drawAt'] === undefined) return false;
    if (!('qualificationMode' in value) || value['qualificationMode'] === undefined) return false;
    if (!('prizes' in value) || value['prizes'] === undefined) return false;
    if (!('autoDistributedRewards' in value) || value['autoDistributedRewards'] === undefined) return false;
    return true;
}

export function ChallengeDrawFromJSON(json: any): ChallengeDraw {
    return ChallengeDrawFromJSONTyped(json, false);
}

export function ChallengeDrawFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeDraw {
    if (json == null) {
        return json;
    }
    return {
        
        '_id': json['_id'] == null ? undefined : json['_id'],
        'drawAt': json['drawAt'],
        'qualificationMode': RewardSelectionFromJSON(json['qualificationMode']),
        'prizes': ((json['prizes'] as Array<any>).map(DrawPrizeFromJSON)),
        'label': json['label'] == null ? undefined : json['label'],
        'autoDistributedRewards': json['autoDistributedRewards'],
        'drawCompletedAt': json['drawCompletedAt'] == null ? undefined : json['drawCompletedAt'],
        'rewardsDistributedAt': json['rewardsDistributedAt'] == null ? undefined : json['rewardsDistributedAt'],
        'winnerCount': json['winnerCount'] == null ? undefined : json['winnerCount'],
        'requireSegmentActivity': json['requireSegmentActivity'] == null ? undefined : json['requireSegmentActivity'],
        'qualification': json['qualification'] == null ? undefined : DrawQualificationFromJSON(json['qualification']),
        'requiresAttention': json['requiresAttention'] == null ? undefined : json['requiresAttention'],
        'attentionReason': json['attentionReason'] == null ? undefined : json['attentionReason'],
    };
}

export function ChallengeDrawToJSON(json: any): ChallengeDraw {
    return ChallengeDrawToJSONTyped(json, false);
}

export function ChallengeDrawToJSONTyped(value?: ChallengeDraw | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '_id': value['_id'],
        'drawAt': value['drawAt'],
        'qualificationMode': RewardSelectionToJSON(value['qualificationMode']),
        'prizes': ((value['prizes'] as Array<any>).map(DrawPrizeToJSON)),
        'label': value['label'],
        'autoDistributedRewards': value['autoDistributedRewards'],
        'drawCompletedAt': value['drawCompletedAt'],
        'rewardsDistributedAt': value['rewardsDistributedAt'],
        'winnerCount': value['winnerCount'],
        'requireSegmentActivity': value['requireSegmentActivity'],
        'qualification': DrawQualificationToJSON(value['qualification']),
        'requiresAttention': value['requiresAttention'],
        'attentionReason': value['attentionReason'],
    };
}

